import { AccountActionTypes, AccountActions } from './account.actions';
import { IAccount } from '../../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IAccount | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: AccountActions): State {
    switch (action.type) {

        case AccountActionTypes.LoadAccountState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case AccountActionTypes.LoadAccountStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case AccountActionTypes.LoadAccountStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case AccountActionTypes.AccountScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;